import { Textarea, TextField } from '@/shared/components/TextField';
import CreateLayout from '@/shared/layout/createLayout';
import ErrorPage403 from '@/app/routes/errorPage403';
import Loader from '@/app/routes/Loader';
import { SERVICE_TYPE_LABELS } from '../../constants/labels';
import { useCreateServiceType } from '../../hooks/useCreateServiceType';
import { useUserPrivileges } from '@shared/hooks/useUserPrivileges';

const CreateServiceType: React.FC = () => {
  const {
    formData,
    errors,
    isSubmitting,
    isCancelModalOpen,
    isSnackbarOpen,
    snackbarError,
    handleServiceNameChange,
    handleDescriptionChange,
    handleSubmit,
    handleCancel,
    handleCloseCancelModal,
    handleConfirmCancel,
    handleCloseSnackbar,
  } = useCreateServiceType();

  const { privileges, isLoading } = useUserPrivileges();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center bg-white h-screen w-full">
        <Loader />
      </div>
    );
  }

  if (!privileges.serviceTypeCreate) {
    return <ErrorPage403 />;
  }

  const Header = () => (
    <p className="text-titleLarge text-neutral-10">
      {SERVICE_TYPE_LABELS.CREATE_TITLE}
    </p>
  );

  return (
    <CreateLayout
      isSubmitting={isSubmitting}
      handleSubmit={handleSubmit}
      handleCancel={handleCancel}
      isCancelModalOpen={isCancelModalOpen}
      handleCloseCancelModal={handleCloseCancelModal}
      handleConfirmCancel={handleConfirmCancel}
      isSnackbarOpen={isSnackbarOpen}
      handleCloseSnackbar={handleCloseSnackbar}
      snackbarError={snackbarError}
      Header={Header}
      submitButtonLabel={SERVICE_TYPE_LABELS.BUTTON_CREATE}
      submitButtonLoadingLabel={SERVICE_TYPE_LABELS.BUTTON_CREATE_LOADING}
      cancelButtonLabel={SERVICE_TYPE_LABELS.BUTTON_CANCEL}
      submitButtonDisabled={isSubmitting}
    >
      <div className="flex flex-col gap-2">
        <p className="text-[18px] text-on-surface-variant">
          {SERVICE_TYPE_LABELS.SECTION_DETAILS}
        </p>
        <div className="flex flex-col gap-8">
          <div className="flex gap-4">
            <TextField
              type="text"
              inputMode="text"
              label={SERVICE_TYPE_LABELS.FIELD_NAME}
              maxLength={50}
              width={'50%'}
              autoFocus
              autoComplete="off"
              value={formData.serviceName}
              onChange={handleServiceNameChange}
              error={Boolean(errors.serviceName)}
              errorMessage={errors.serviceName ?? ''}
              disabled={isSubmitting}
            />
          </div>
          <Textarea
            label={SERVICE_TYPE_LABELS.FIELD_DESCRIPTION}
            maxLength={500}
            fullWidth
            rows={4}
            value={formData.description}
            onChange={handleDescriptionChange}
            error={Boolean(errors.description)}
            errorMessage={errors.description ?? ''}
            disabled={isSubmitting}
          />
        </div>
      </div>
    </CreateLayout>
  );
};

export default CreateServiceType;
